import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Moment from 'moment';
import isNaN from 'lodash/isNaN';
import {
  DropdownButton,
  MenuItem
} from 'react-bootstrap';

import { Dropdown } from 'components/Dropdown/Dropdown';
import * as ScheduleRFSActionType from '../constants';
import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';
import * as ProjectActionType from 'Projects/constants';
import * as RequestTypes from 'Request-Types/constants';
import * as AuthActionType from '../../Auth/constants';
import Translate from 'components/translate';
import Radio from 'components/CustomRadio/CustomRadio';
import Datetime from 'react-datetime';

class AddRFS extends Component {
  static propTypes = {
    location: PropTypes.object,
    onSelectedLot: PropTypes.func,
    onSelectedStatus: PropTypes.func,
    history: PropTypes.object,
    dispatch: PropTypes.func,
    RFSStore: PropTypes.object,
    projectList: PropTypes.array,
    requestTypeList: PropTypes.array,
    userList: PropTypes.array,
    adminSelectList: PropTypes.array,
    lots: PropTypes.array,
    loading: PropTypes.any,
    UserProfile: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.queryParams = new URLSearchParams(this.props.location.search);
    this.state = {
      project: this.queryParams.get('isFromLot') ? {
        value: this.queryParams.get('projectId'),
        text: this.queryParams.get('projectName'),
        extensionValue: null,
        selected: false
      } : null,
      lot: this.queryParams.get('isFromLot') ? {
        value: this.queryParams.get('lotId'),
        text: this.queryParams.get('lotNumber') + ', ' + this.queryParams.get('streetAddress'),
        extensionValue: {
          coe: this.queryParams.get('coe'),
          lawsuit: 'no',
          streetAddress: this.queryParams.get('streetAddress')
        },
        selected: false
      } : null,
      requestType: null,
      user: null,
      projectList: props.projectList,
      lots: props.lots,
      requestTypeList: props.requestTypeList,
      userList: props.userList,
      loading: false,
      isFetchingProject: false,
      isFetchingLot: false,
      isFetchingRequestType: false,
      isFetchingUser: false,
      check: false,
      radio: this.lot && this.lot.extensionValue.coe ? 'coe' : 'lot',
      issuedIn: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.projectList) { this.setState({ isFetchingProject: false }); }
    if (nextProps.lots) { this.setState({ isFetchingLot: false }); }
    if (nextProps.requestTypeList) { this.setState({ isFetchingRequestType: false }); }
    if (nextProps.userList) { this.setState({ isFetchingUser: false }); }
    if (nextProps.loading.refNo && this.state.loading && nextProps.loading !== this.state.loading) {
      this.props.history.push(`/request-for-services/work-order/add/${nextProps.loading.refNo}`);
    }
  }

  onChangeScheduleDate = (scheduleDate) => {
    if (scheduleDate) {
      if (Moment(scheduleDate, 'MM/DD/YYYY', true).isValid()) {
        this.setState({
          scheduleDate,
          errorDate: null
        }, () => {
          const today = Moment();
          if (today.diff(scheduleDate) > 0) {
            this.setState({
              errorDate: `Scheduled date ${Moment(scheduleDate).format('MM/DD/YYYY')} is in the past.`
            });
          }
        });
      } else {
        this.setState({
          errorDate: 'Invalid datetime.'
        });
      }
    } else {
      this.setState({
        scheduleDate: null,
        errorDate: 'Invalid datetime.'
      });
    }
  }

  fetchProjectList = () => {
    this.setState({
      isFetchingProject: true
    });
    this.props.dispatch({
      type: ProjectActionType.SELECT_LIST_PROJECT_ASYNC,
      params: {
        param: { searchKey: '', selectedValue: '' }
      },
      callback: () => {
        this.setState({ isFetchedProject: true });
      }
    });
  }

  fetchLots = () => {
    if (this.state.project) {
      this.setState({
        isFetchingLot: true
      });
      this.props.dispatch({
        type: ProjectActionType.SELECT_LIST_LOT_ASYNC,
        params: {
          id: this.state.project.value,
          searchKey: '',
          selectedValue: '',
          setDefaultSelected: false
        },
        callback: () => {
          this.setState({ isFetchedLot: true });
        }
      });
    }
  }

  fetchRequestType = () => {
    this.setState({
      isFetchingRequestType: true
    });
    this.props.dispatch({
      type: RequestTypes.SELECT_LIST_ITEM_ASYNC,
      params: {
        searchKey: '',
        selectedValue: '',
        isBlueTape: false
      }
    });
  }

  fetchUser = () => {
    this.setState({
      isFetchingUser: true
    });
    if (this.state.check) {
      this.props.dispatch({
        type: AuthActionType.SELECT_LIST_ADMIN_SUPER_ADMIN_ASYNC,
        params: {
          searchKey: '',
          selectedValue: ''
        }
      });
    } else {
      if (this.state.project) {
        this.props.dispatch({
          type: ProjectActionType.GET_LIST_USER_ASYNC,
          params: {
            projectId: this.state.project.value
          }
        });
      }
    }
  }

  onCancel() {
    this.props.history.push('/request-for-services');
  }

  onSelectChange = (event, name) => {
    if (name === 'project') {
      var user = event.value.extensionValue;
      // user['_$visited'] = true;
      this.setState({
        lot: null,
        user: user,
        [name]: event.value
      });
    } else if (name === 'lot') {
      if (event.value.extensionValue.coe) {
        this.setState({
          [name]: event.value,
          radio: 'coe'
        }, () => {
          if (this.state.issuedIn) {
            this.onSetScheduleDate({target: {value: this.state.issuedIn}});
          }
        });
      } else {
        this.setState({
          [name]: event.value,
          radio: 'lot'
        }, () => {
          if (this.state.issuedIn) {
            this.onSetScheduleDate({target: {value: this.state.issuedIn}});
          }
        });
      }
    } else {
      this.setState({
        [name]: event.value
      });
    }

  }

  onChecked = () => {
    this.setState({
      check: !this.state.check,
      user: null
    });
  }

  onSubmit = () => {
    let scheduleDate = '';
    const { project, lot, requestType, user, radio, issuedIn, setScheduleOnDate } = this.state;
    if (!project || !lot || !requestType || !user) {
      return;
    }
    if (setScheduleOnDate) {
      scheduleDate = Moment(this.state.scheduleDate).format();
    } else {
      if (radio === 'coe') {
        scheduleDate = Moment(lot.extensionValue.coe).add(Number(issuedIn), 'days').format();
      } else {
        scheduleDate = Moment(lot.extensionValue.creationDate).add(Number(issuedIn), 'days').format();
      }
    }
    this.setState({ loading: true });
    this.props.dispatch({
      type: ScheduleRFSActionType.ADD_SCHEDULE_RFS_ASYNC,
      payload: {
        'projectId': project.value,
        'lotId': lot.value,
        'requestTypeId': requestType.value,
        'managedByUserId': user.value,
        scheduleDate: Moment(scheduleDate).add(8, 'hours').format()
      },
      callback: (data) => {
        this.props.history.push(`/request-for-services/schedule-work-order/add/${data.refNo}`);
      }
    });
  }

  handleRadio = event => {
    const target = event.target;
    this.setState({
      [target.name]: target.value
    }, () => {
      if (this.state.issuedIn) {
        this.onSetScheduleDate({target: {value: this.state.issuedIn}});
      }
    });

  }

  onSetScheduleDate = e => {
    const {radio, lot} = this.state;
    const issuedIn = e.target.value;

    if (!isNaN(Number(issuedIn))) {
      if (Number(issuedIn) < 1) {
        this.setState({ issuedIn: '', errorDate: '' });
      } else if (Number(issuedIn) > 366) {
        this.setState({ issuedIn: '366' });
      } else {
        let scheduleDate = '';
        const today = Moment().format('MM/DD/YYYY');
        if (radio === 'coe') {
          scheduleDate = Moment(lot.extensionValue.coe).add(Number(issuedIn), 'days').format('MM/DD/YYYY');
        } else {
          scheduleDate = Moment(lot.extensionValue.creationDate).add(Number(issuedIn), 'days').format('MM/DD/YYYY');
        }

        if (Moment(today).isSameOrAfter(scheduleDate, 'day')) {
          this.setState({ issuedIn: Number(issuedIn), errorDate: `Scheduled date ${Moment(scheduleDate).format('MM/DD/YYYY')} is in the past.` });
        } else {
          this.setState({ issuedIn: Number(issuedIn), errorDate: '' });
        }

      }
    }
    {/* else {
      this.setState({ issuedIn: '', errorDate: '' });
    }*/}

  }

  validPastDate = (current) => {
    const yesterday = Datetime.moment();
    return current.isAfter(yesterday);
  }

  renderScheduleDate() {
    const { lot, setScheduleOnDate, errorDate } = this.state;
    if (setScheduleOnDate) {
      return (
        <div className='scheduled-request-date issued-on-date'>
          <div>
            <a data-toggle='dropdown'>Issued on date <span className='text-danger'>*</span></a>
            <DropdownButton className='pull-left text-' style={{border: 'none'}} id='dropdown-item-button' title={<i className='pe-7s-angle-down' />} noCaret={true}>
              <MenuItem onClick={() => this.setState({ setScheduleOnDate: false, scheduleDate: null, errorDate: null })}>Issued in</MenuItem>
            </DropdownButton>
          </div>

          <div>
            <Datetime
              ref={ref => { this.scheduleDate = ref; }}
              name='scheduleDate'
              inputProps={{ placeholder: 'mm/dd/yyyy' }}
              timeFormat={false}
              isValidDate={this.validPastDate}
              value={this.state.scheduleDate}
              onChange={this.onChangeScheduleDate} 
              closeOnSelect={true}/>
            {errorDate &&
              <span className='text-danger' style={{fontSize: 12}}>{errorDate}</span>
            }
          </div>

        </div>
      );

    }
    return (
      <div className='scheduled-request-date'>
        <div>
          <a data-toggle='dropdown'>Issued in <span className='text-danger'>*</span></a>
          <DropdownButton className='pull-left text-' style={{border: 'none', backgroundColor: 'transparent'}} id='dropdown-item-button' title={<i className='pe-7s-angle-down' />} noCaret={true}>
            <MenuItem onClick={() => this.setState({ setScheduleOnDate: true, issuedIn: '', errorDate: null })}>Issued on date</MenuItem>
          </DropdownButton>
        </div>

        <div>
          <input
            type='text'
            className='input-amount'
            ref={ref => { this.issuedIn = ref; }}
            value={this.state.issuedIn}
            onChange={this.onSetScheduleDate}
            disabled={!lot}
          />

        </div>
        <div>
          &nbsp; &nbsp; days from
        </div>

        <div className='radio-wrapper'>
          <div className='site-one-radio'>
            <Radio
              number='0dr'
              option='coe'
              name='radio'
              onChange={this.handleRadio}
              checked={this.state.radio === 'coe'}
              label='original COE date'
              disabled={(lot && lot.extensionValue.coe) ? false : true}
            />
          </div>
          <div className='site-one-radio'>
            <Radio
              number='1dr'
              option='lot'
              name='radio'
              onChange={this.handleRadio}
              checked={this.state.radio === 'lot'}
              label='lot creation date'
            />
            <div className='creation-date'>{this.state.radio === 'lot' && lot && `(${Moment(lot.extensionValue.creationDate).format('MM/DD/YYYY')})`}</div>
          </div>
        </div>

      </div>
    );
  }

  render() {

    const { project, lot, requestType, user, issuedIn, scheduleDate, errorDate, isShowIssuedOnDateButton, setScheduleOnDate } = this.state;

    const disable = !project || !lot || !requestType || !user || !(issuedIn || scheduleDate) || errorDate;
    return <div className='add-rfs'>
      <div className='page-title clearfix'>
        <h2 className='pull-left'>Add new schedule request</h2>
      </div>
      <ul className='breadcrumb'>
        <li><Link to={'/request-for-services'}>Requests for service</Link></li>
        <li className='breadcrumb-siteone-li'>Add new scheduled request</li>
      </ul>
      <div className='box-form-siteone'>
        <div className='box-form-body'>
          <p className='col-sm-12' style={{ opacity: .6 }}>Specify the <Translate translateKey='lot' /> that requires service</p>
          <div className='form-group'>
            <label className='col-md-12'><Translate translateKey='project' plurals capitalize /> <span className='text-danger'>*</span></label>
            <div className='col-md-6'>
              <Dropdown
                filter={true}
                onChange={ref => { this.onSelectChange(ref, 'project'); }}
                className='filestring-dropdown filter-dropdown'
                optionLabel='text'
                placeholder='Please select'
                style={{ width: '100%' }}
                options={this.state.isFetchedProject ? this.props.projectList : [{ ...this.state.project }]}
                loading={this.state.isFetchingProject}
                name='projectList'
                onRemote={this.fetchProjectList}
                value={project}
              />
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-12'><Translate translateKey='lot' capitalize /> <span className='text-danger'>*</span></label>
            <div className='col-md-6'>
              <Dropdown
                filter={true}
                onChange={ref => { this.onSelectChange(ref, 'lot'); }}
                className='filestring-dropdown filter-dropdown'
                placeholder='Please select'
                style={{ width: '100%' }}
                options={this.state.isFetchedLot ? this.props.lots : [{ ...this.state.lot }]}
                disabled={!this.state.project}
                loading={this.state.isFetchingLot}
                onRemote={this.fetchLots}
                optionLabel='text'
                value={lot}
              />
            </div>
            {lot &&
              <div className='col-md-9 text-left' style={{ marginTop: -10, marginBottom: 15 }}>
                Original COE: {lot.extensionValue.coe ? Moment(lot.extensionValue.coe).format('MM/DD/YYYY') : <span style={{ opacity: 0.5 }}>(Not specified)</span>}
              </div>
            }
          </div>
          <div className='form-group'>
            <label className='col-md-12'>Request type <span className='text-danger'>*</span></label>
            <div className='col-md-6'>
              <Dropdown
                filter={true}
                onChange={ref => { this.onSelectChange(ref, 'requestType'); }}
                className='filestring-dropdown filter-dropdown'
                placeholder='Please select'
                options={this.props.requestTypeList}
                loading={this.state.isFetchingRequestType}
                style={{ width: '100%' }}
                optionLabel='text'
                onRemote={this.fetchRequestType}
                value={requestType}
              />
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-12'>RFS managed by <span className='text-danger'>*</span></label>
            <div className='col-md-6'>
              {this.props.UserProfile.sso
                ? <Dropdown
                  filter={true}
                  onChange={ref => { this.onSelectChange(ref, 'user'); }}
                  className='filestring-dropdown filter-dropdown'
                  placeholder='Please select'
                  onRemote={this.fetchUser}
                  options={this.state.check ? this.props.adminSelectList : this.props.userList}
                  loading={this.state.isFetchingUser}
                  disabled={!this.state.project && !this.state.check}
                  value={user}
                  optionLabel='text'
                  groupLabels={[
                    {
                      label: 'System users',
                      field: 'sso',
                      condition: [true]
                    },
                    {
                      label: 'Builder users',
                      field: 'sso',
                      condition: [false, null]
                    }
                  ]}
                  style={{ width: '100%', marginBottom: 0 }}
                />
                : <Dropdown
                  filter={true}
                  onChange={ref => { this.onSelectChange(ref, 'user'); }}
                  className='filestring-dropdown filter-dropdown'
                  placeholder='Please select'
                  onRemote={this.fetchUser}
                  options={this.state.check ? this.props.adminSelectList : this.props.userList}
                  loading={this.state.isFetchingUser}
                  disabled={!this.state.project && !this.state.check}
                  value={user}
                  optionLabel='text'
                  style={{ width: '100%', marginBottom: 0 }}
                />}

              <CheckBoxSingle
                style={{ marginTop: 0 }}
                checked={this.state.check}
                ref={c => { this.check = c; }}
                name='checkAdmin'
                label='I want to assign this request to admin'
                className='checkbox-default noteTitle'
                onChecked={this.onChecked} />
            </div>
          </div>
          <div className='form-group'>
            <div className='col-sm-12' style={{ marginBottom: 30, marginTop: 10 }}>
              {this.renderScheduleDate()}
              <div>
                {isShowIssuedOnDateButton && setScheduleOnDate && <button onClick={() => this.setState({ setScheduleOnDate: false, isShowIssuedOnDateButton: false, scheduleDate: null })}>Issued in</button>}
              </div>
              <div>
                {isShowIssuedOnDateButton && !setScheduleOnDate && <button onClick={() => this.setState({ setScheduleOnDate: true, isShowIssuedOnDateButton: false, issuedIn: '' })}>Issued on date</button>}
              </div>
              {!this.state.setScheduleOnDate && <div className='text-danger'>{errorDate}</div>}
            </div>
          </div>
          <div className='form-group'>
            <div className='col-sm-12'>
              <button className='btn btn-primary btn-siteone-default btn-wo-edit' style={{ marginRight: 15 }} onClick={() => { this.props.history.push('/request-for-services'); }}>Cancel</button>
              <button className='btn btn-siteone' disabled={disable} onClick={this.onSubmit}>Proceed to request for service</button>
            </div>
          </div>
          <div className='clearfix' />
        </div>
      </div>
    </div>;
  }
}

const mapStateToProps = (state) => {
  return {
    projectList: state.ProjectStore.ProjectList,
    lots: state.ProjectStore.LotList,
    requestTypeList: state.RequestTypeStore.ItemList,
    userList: state.ProjectStore.UserSelectList,
    adminSelectList: state.authReducer.adminSelectList,
    loading: state.RFSStore.Loading,
    UserProfile: state.UserStore.UserProfile
  };
};

export default connect(mapStateToProps)(AddRFS);



// WEBPACK FOOTER //
// ./src/Request-Services/Containers/add-schedule-rfs.js